import React from 'react';
import './analyticsAsk.css';

/** "This needs a full report" — CTA hands off to the existing cohort-report builder. */
export default function ReportSuggestedCard({ reason, onGenerateReport }) {
  return (
    <div className="aa-report">
      <strong>This one needs a full report.</strong>
      <p>{reason || 'That question spans more than the instant answer can cover reliably.'}</p>
      <button type="button" className="aa-report__cta" onClick={onGenerateReport}>Generate a full report →</button>
    </div>
  );
}
